import { defineStore } from "pinia";
import { rootGetters } from "@/main";
import { DictionaryItem, getMap } from "@/services/segments/dictionaries";

const endpoints = {
    getStates: { method: "get", url: "/dictionaries/campaign_states" },
    getSegmentStates: { method: "get", url: "/dictionaries/campaign_segment_states" },
};

export const useCampaignsDictionariesStore = defineStore("campaignsDictionaries", {
    state: () => ({
        segmentsStates: [] as DictionaryItem[],
        states: [] as DictionaryItem[]
    }),
    getters: {
        statesSegmentsMap(state) {
            return getMap(state.segmentsStates)
        },
        statesMap(state) {
            return getMap(state.states)
        },
        statesAllowed(state) {
            if (state.states)
                return state.states.filter(st => st.name !== "deleted" && st.name != "archived");
            return [];
        },
        segmentsStatesAllowed(state) {
            if (state.segmentsStates)
                return state.segmentsStates.filter(st => st.name !== "deleted" && st.name != "archived");
            return [];
        },
        segmentsStatesForStatistics(state) {
            if (state.segmentsStates)
                return state.segmentsStates.filter(st => st.name === "ready" || st.name === "deleted_in_platform" || st.name === "processing");
            return [];
        },
        defaultStates(state) {
            const states: number[] = [];
            if (state.states)
                state.states.forEach(e => {
                    if (!['archived', 'deleted'].includes(e.name)) states.push(e.id);
                })
            return states.join(",");
        },
        defaultSegmentsStates(state) {
            const states: number[] = [];
            if (state.segmentsStates)
                state.segmentsStates.forEach(e => {
                    if (!['archived', 'deleted'].includes(e.name)) states.push(e.id);
                })
            return states.join(",");
        }
    },
    actions: {
        async getSegmentsStates() {
            await rootGetters.api.proceedRequest(endpoints.getSegmentStates).then((response) => {
                this.segmentsStates = response.data;
            });
        },
        async getStates() {
            await rootGetters.api.proceedRequest(endpoints.getStates).then((response) => {
                this.states = response.data;
            });
        }
    }
})

